  <!-- 费项设置 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />

    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @rowCallback="rowCallback" @jumpPage="goYdDetails" />

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 车辆档案新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "费项设置列表", //导出时默认文件名
        apiName: "/admin/v3/tms/itemservice/itemServiceList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:itemservice:addItemService",
        },

        {
          name: "批量启用",
          method: "startUsing",
          permissVal: "admin:itemservice:startItemService",
        },
        {
          name: "批量禁用",
          method: "Disable",
          permissVal: "admin:itemservice:stopItemService",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "费项名称",
          field: "title",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "费项类型",
          field: "itemCategoryId",
          placeholder: "请选择",
          setLabel: "categoryName",
          setValue: "categoryId",
          selectOptions: [],
        },
        {
          type: "select",
          label: "方向类型",
          field: "directionStatus",
          placeholder: "请选择",
          selectOptions: [
            { label: "收", val: "shou:direction_status" },
            { label: "付", val: "fu:direction_status" },
          ],
        },
        {
          type: "select",
          label: "是否禁用",
          field: "isStop",
          placeholder: "请选择",
          selectOptions: [
            { label: "否", val: "0" },
            { label: "是", val: "1" },
          ],
        },
      ],

      queryData: {
        title: null,
        itemCategoryId: null,
        directionStatus: null,
        isStop: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "SetExpenditure", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:itemservice:updateItemService",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:itemservice:delItemService",
            },
            {
              method: "startUsing",
              methodName: "启用",
              permissVal: "admin:itemservice:startItemService",
            },
            {
              method: "Disable",
              methodName: "禁用",
              permissVal: "admin:itemservice:stopItemService",
            },
          ],
        },
        // {
        //   name: "费项编号",
        //   field: "carNumber",
        //   width: "120",
        //   sort: 3,
        //   isShow: true, //是否展示
        //   isTotal: true, //是否开启合计
        //   isSort: true //表格设置里面是否可以排序
        // },
        {
          name: "费项名称",
          field: "title",
          sort: 4,
          isShow: true,
        },
        {
          name: "方向",
          field: "directionStatusShow",
          sort: 5,
          isShow: true,
        },
        {
          name: "金额",
          field: "unitPrice",
          sort: 5,
          isShow: true,
        },
        {
          name: "费项类型",
          field: "categoryName",
          sort: 6,
          isShow: true,
        },
        {
          name: "排序",
          field: "sort",
          sort: 1,
          isShow: true,
        },
        {
          name: "启用状态",
          field: "isStopShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "备注",
          field: "comment",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "新建人",
          field: "createUserName",
          sort: 19,
          isShow: true,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "120",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 2,
          isShow: true,
          isSort: true,
        },
      ],
      sortName: "费项设置", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "费项类型",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 30,
          formItem: [
            {
              span: 12,
              title: "费项名称",
              itemType: "input",
              field: "title",
              labelwidth: 120,
              placeholder: "请输入",
            },
            {
              span: 12,
              title: "归属费项类型",
              itemType: "select",
              labelwidth: 120,
              field: "itemCategoryId",
              placeholder: "请选择",
              setLabel: "categoryName",
              setValue: "categoryId",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "方向",
              itemType: "select",
              labelwidth: 120,
              field: "directionStatus",
              placeholder: "请选择",
              options: [
                { label: "收", val: "shou:direction_status" },
                { label: "付", val: "fu:direction_status" },
              ],
            },
            {
              span: 12,
              title: "默认金额",
              itemType: "input",
              labelwidth: 120,
              field: "unitPrice",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "状态",
              itemType: "select",
              field: "isStop",
              placeholder: "请选择",

              labelwidth: 120,
              options: [
                { label: "禁用", val: 1 },
                { label: "启用", val: 0 },
              ],
            },
            {
              span: 12,
              title: "排序",
              itemType: "input",
              field: "sort",
              labelwidth: 120,
              placeholder: "请输入",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "comment",
              placeholder: "请选择",
            },
          ],
        },
      ],
      formRules: {
        title: [{ required: true, message: "请输入费项名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        unitPrice: [
          { required: true, message: "请输入费项金额", trigger: "blur" },
        ],

        isStop: [{ required: true, message: "请选择状态", trigger: "change" }],
        directionStatus: [
          { required: true, message: "请选择方向类型", trigger: "change" },
        ],
      },
      baseModel: {},
      defaultBaseModel: {
        directionStatus: null,
        isStop: null,
        itemCategoryId: null,
        title: null,
        unitPrice: null,
        comment: null,
        sort: null,
      },
      CategoryPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      DiaCategoryPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },

  created() {
    this.GetData();
    this.GetItemCategoryIds();
  },

  methods: {
    // 获取车辆档案列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.itemServiceList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---费项设置列表`);
        }
      });
    },

    // 获取费项类型下拉列表
    GetItemCategoryIds() {
      this.$API.itemCategorChoose().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          this.diaFormConfig[0].formItem[1].options = result;
          this.baseConfig[1].selectOptions = result;
        }
      });
    },

    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.isShowDialog = true;
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.baseModel = this.selectTableData[0];
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              itemServiceIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.itemServiceIds.push(val.itemServiceId);
            });
            this.$API.delItemService(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.itemServiceIds.length > 2) {
                    delReq.itemServiceIds.map(function (v, i) {
                      num = arr.findIndex(
                        (element) => element.itemServiceId == v
                      );
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) =>
                        element.itemServiceId == delReq.itemServiceIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 启用
    startUsing(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "启用";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认${msg}所选数据?`, "提示:")
          .then((res) => {
            let params = {
              itemServiceIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.itemServiceIds.push(val.itemServiceId);
            });

            if (t) {
              // 禁用接口
              this.$API.stopItemService(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            } else {
              // 启用接口
              this.$API.startItemService(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 禁用
    Disable(data) {
      this.startUsing(data, "禁用");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.baseModel.itemServiceId)
            param.itemServiceId = this.baseModel.itemServiceId;
          if (param.itemServiceId) {
            // 修改接口
            this.$API.updateItemService(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addItemService(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },
  },
};
</script>
  <style scoped lang="less">
</style>
  